import React from 'react';

interface CustomInputProps {
  label: string;
  id: string;
  value: string | number;
  onChange: (v: string) => void;
  type?: string;
  placeholder?: string;
  maxLength?: number;
  className?: string;
}

const CustomInput: React.FC<CustomInputProps> = React.memo(({ label, id, value, onChange, type = 'text', placeholder, maxLength, className }) => (
  <div className={`display-flex flex-column ${className || ''}`}>
    <div className="display-flex">
      <label htmlFor={id}>{label}</label>
    </div>
    <div className="display-flex">
      <input
        id={id}
        className="form-control"
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
      />
    </div>
  </div>
));

export default CustomInput; 